"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var merchandiseAdapter = function merchandiseAdapter(merchandiseCatalog) {
  return merchandiseCatalog.reduce(function (accumulator, merchandiseItem) {
    accumulator.products[merchandiseItem.id] = merchandiseItem;
    return accumulator;
  }, {
    products: {}
  });
};

var _default = merchandiseAdapter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/merchandiseAdapter.js
// module id = 725
// module chunks = 5 6